const commonStyle = {
  backgroundRepeat: "no-repeat",
  backgroundPosition: `center right`,
  position: "relative",
  backgroundColor: "primary.90",
};

const styles = {
  ED: {
    desktop: {
      container: {
        ...commonStyle,
        backgroundRepeat: "no-repeat",
        backgroundPosition: `center right`,
        backgroundSize: "40%",
        backgroundImage: `url('/images/onefront/bluestone/ED/prime-lightbox/pattern-edreams.svg')`,
      },
    },
    mobile: {
      container: {
        ...commonStyle,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        backgroundPosition: `calc(300%) center`,
        backgroundImage: `url('/images/onefront/bluestone/ED/prime-lightbox/pattern-edreams.svg')`,
      },
    },
  },
  OP: {
    desktop: {
      container: {
        ...commonStyle,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        backgroundPosition: `center right`,
        backgroundImage: `url('/images/onefront/bluestone/OP/prime-lightbox/pattern-opodo-prime.svg')`,
      },
    },
    mobile: {
      container: {
        ...commonStyle,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        backgroundPosition: `calc(300%) center`,
        backgroundImage: `url('/images/onefront/bluestone/OP/prime-lightbox/pattern-opodo-prime.svg')`,
      },
    },
  },
  GO: {
    desktop: {
      container: {
        ...commonStyle,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        backgroundPosition: `center right`,
        backgroundImage: `url('/images/onefront/bluestone/GV/prime-lightbox/pattern-govoyages.svg')`,
      },
    },
    mobile: {
      container: {
        ...commonStyle,
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto",
        backgroundPosition: `calc(300%) center`,
        backgroundImage: `url('/images/onefront/bluestone/GV/prime-lightbox/pattern-govoyages.svg')`,
      },
    },
  },
  TR: {
    desktop: {
      container: {
        ...commonStyle,
      },
    },
    mobile: {
      container: {
        ...commonStyle,
      },
    },
  },
};

export default styles;
